import { React } from "react";
import { RunnerUpHeader } from "../../../ui";
import { useGetEpbScanningRoReportQuery } from "../../../services/reportsServices";
import pdfIcon from "../../../images/pdfIcon.png";
import excelIcon from "../../../images/excelIcon.png";
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils";
import LeftMenu from "../../AnalyticsModule/Left";
import { useEffect, useState } from "react";
import "../RO/roReport.css";

const tableHeader = [
  "Counting Supervisor id ",
  "Scanning number",
  "Serial number in Part",
  "e-pb id",
  "Service elector name",
  "Status",
];

const EpbScanningRoReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState();
  const [tabledata, setTabledata] = useState([]);
  const [skip, setskip] = useState(false);
  const reportName = "e-Postal Ballot PreCounting Report";
  const SheetName = "Scanning Report";
  const tableHeader = [];
  const columns = [
    {
      Header: "Scanned By",
      accessor: "col1",
    },
    {
      Header: "Scanning Number",
      accessor: "col2",
    },
    {
      Header: "Serial Number in Part",
      accessor: "col3",
    },
    {
      Header: "e-PB Id",
      accessor: "col4",
    },
    {
      Header: "Service Elector Name",
      accessor: "col5",
    },
    {
      Header: "Reason for Rejection (Postal Ballot)",
      accessor: "col6",
    },
    {
      Header: "Status",
      accessor: "col7",
    },
  ];
  columns.map((item) => {
    tableHeader.push(item.Header);
  });
  const { data: GetEpbScanningRoReport } = useGetEpbScanningRoReportQuery();

  useEffect(() => {
    if (GetEpbScanningRoReport?.payload != null) {
      var tableData = [];
      GetEpbScanningRoReport?.payload?.epostaBallotScanningByRoDetailDto?.map(
        (item) => {
          tableData.push({
            col1: item.userId.toUpperCase() ? item.userId.toUpperCase() : "NA",
            col2: item.scanningNo ? item.scanningNo : "NA",
            col3: item.serialNoInPart ? item.serialNoInPart : "NA",
            col4: item.epbId ? item.epbId : "NA",
            col5: item.serviceElectorName ? item.serviceElectorName : "NA",
            col6: item.invalidReason ? item.invalidReason : "NA",
            col7: item.status ? item.status : "NA",
          });
        }
      );
      setTabledata(tableData);
      setTotalNoOfRecords(
        GetEpbScanningRoReport?.payload?.epostaBallotScanningByRoDetailDto
          ?.length
      );
      setskip(true);
    }
  }, [GetEpbScanningRoReport]);
  return (
    <LeftMenu>
      <div className="container box shadow ">
        <div className="col-md-12">
          <RunnerUpHeader
            label={
              <>
                <p>
                  {reportName}
                  <span
                    style={{
                      marginLeft: "40px",
                      color: "white",
                      fontSize: "13px",
                    }}
                  >
                    State: {GetEpbScanningRoReport?.payload?.stateName}{" "}
                    <span style={{ marginLeft: "13px" }}></span>Constituency :{" "}
                    {GetEpbScanningRoReport?.payload?.acPcNo}-
                    {GetEpbScanningRoReport?.payload?.acPcName} -{" "}
                    {GetEpbScanningRoReport?.payload?.constType}
                  </span>
                </p>
              </>
            }
            search={
              <div className="col-md-4 row">
                <div>
                  <img
                    src={pdfIcon}
                    width="35px"
                    height="28px"
                    className=" reports_icon_button"
                    onClick={() =>
                      downloadPdfFile(reportName, tableHeader, tabledata, false, true)
                    }
                  />
                </div>
                <div className="ml-4">
                  <img
                    src={excelIcon}
                    width="40px"
                    height="30px"
                    className=" reports_icon_button"
                    onClick={() =>
                      downloadExcelFile(
                        reportName,
                        SheetName,
                        tableHeader,
                        tabledata, true
                      )
                    }
                  />
                </div>
              </div>
            }
          />
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                {/* <div className="col-md-6 box ml-3"> */}
                <label className="label_text">
                  {/* <b style={{ color: "black" }}>State :</b> {GetEpbScanningRoReport?.payload?.stateName} */}
                </label>
                {/* </div> */}
                {/* <div className="col-md-5 box ml-5"> */}
                <label className="label_text">
                  {/* <b style={{ color: "black" }}>AC/PC :</b> {GetEpbScanningRoReport?.payload?.acPcNo}-
                {GetEpbScanningRoReport?.payload?.acPcName} */}
                </label>
                {/* </div> */}
              </div>
              <div className="row">
                {/* <div className="col-md-2 box ml-3">
                  <label className="label_text">
                    <b style={{ color: "black" }}>Total e-PB valid :</b>{" "}
                    {GetEpbScanningRoReport?.payload?.validEpbScannigCount}
                  </label>
                </div> */}

                <div class="reports col-md-3">
                  <div class="card l-bg-green">
                    <div
                      class="card-statistic-3 p-4 card-height-reports"
                      style={{ height: "60px" }}
                    >
                      <div class="card-icon card-icon-large">
                      </div>
                      <div class="row align-items-center mb-2 d-flex">
                        <div class="col-10 card-text-alignment-booked-report">
                          <h5 class="d-flex align-items-center mb-0" style={{width:"max-content"}}>
                            <b style={{ color: "white", marginLeft: "30px" }}>
                              Valid e-PB:{" "}
                            </b>{" "}
                            {
                              <span
                                style={{
                                  marginLeft: "7px",
                                  fontSize: "21px",
                                }}
                              >
                                {
                                  GetEpbScanningRoReport?.payload
                                    ?.validEpbScannigCount
                                }
                              </span>
                            }
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-3 box ml-3 ">
                  <label className="label_text">
                    <b style={{ color: "black" }}>Total e-PB invalid :</b>{" "}
                    {GetEpbScanningRoReport?.payload?.invalidEpbScannigCount}
                  </label>
                </div> */}
                <div class=" reports col-md-3">
                  <div class="card l-bg-cherry">
                    <div
                      class="card-statistic-3 p-4 card-height-reports"
                      style={{ height: "60px" }}
                    >
                      <div class="card-icon card-icon-large">
                      </div>
                      <div class="row align-items-center mb-2 d-flex">
                        <div class="col-10 card-text-alignment">
                          <h5 class="d-flex align-items-center mb-0" style={{width:"max-content"}}>
                            <b style={{ color: "white", marginRight: "9px" }}>Invalid e-PB :</b>{" "}
                            <span
                              style={{
                                fontSize: "20px",
                              }}
                            >
                              {
                                GetEpbScanningRoReport?.payload
                                  ?.invalidEpbScannigCount
                              }
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="reports col-md-3">
                  <div class="card l-bg-orange-dark">
                    <div
                      class="card-statistic-3 p-4 card-height-reports"
                      style={{ height: "60px" }}
                    >
                      <div class="card-icon card-icon-large">
                      </div>
                      <div class="row align-items-center mb-2 d-flex">
                        <div class="col-10 card-text-alignment ">
                          <h5 class="d-flex align-items-center mb-0">
                            <b style={{ color: "white", marginTop: "-18px" }}>
                              Duplicate e-PB :
                            </b>{" "}
                            <span
                              style={{
                                marginRight: "50px",
                                marginTop: "8px",
                                fontSize: "22px",
                              }}
                            >
                              {
                                GetEpbScanningRoReport?.payload
                                  ?.duplicateEpbScannigCount
                              }
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-3 box ml-3">
                  <label className="label_text">
                    <b style={{ color: "black" }}>
                      Total e-PB manually Rejected :
                    </b>{" "}
                    {GetEpbScanningRoReport?.payload?.manuallyRejectedEpbCount}
                  </label>
                </div> */}
                <div class=" reports col-md-3">
                  <div class="card l-bg-blue-dark">
                    <div
                      class="card-statistic-3 p-4 card-height-reports"
                      style={{ height: "60px" }}
                    >
                      <div class="card-icon card-icon-large">
                      </div>
                      <div class="row align-items-center mb-2 d-flex">
                        <div class="col-10 card-text-alignment ">
                          <h5 class="d-flex align-items-center mb-0">
                            <b
                              style={{
                                color: "white",
                                fontSize: "17px",
                                marginTop: "-13px",
                              }}
                            >
                              Manually Rejected e-PB :
                            </b>{" "}
                            <span
                              style={{ marginBottom: "-8px", fontSize: "22px" }}
                            >
                              {
                                GetEpbScanningRoReport?.payload
                                  ?.manuallyRejectedEpbCount
                              }
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" reports col-md-3">
                <div class="card l-bg-yellow-dark">
                    <div
                      class="card-statistic-3 p-4 card-height-reports"
                      style={{ height: "60px" }}
                    >
                      <div class="card-icon card-icon-large">
                      </div>
                      <div class="row align-items-center mb-2 d-flex">
                        <div class="col-10 card-text-alignment ">
                          <h5 class="d-flex align-items-center mb-0">
                            <b
                              style={{
                                color: "white",
                                fontSize: "17px",
                                marginTop: "-13px",
                              }}
                            >
                              Incomplete Scanned :
                            </b>{" "}
                            <span
                              style={{ marginBottom: "-8px", fontSize: "22px" }}
                            >
                              {
                                GetEpbScanningRoReport?.payload
                                  ?.incompleteCount===null?0:GetEpbScanningRoReport?.payload
                                  ?.incompleteCount
                              }
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" reports col-md-3">
                <div class="card l-bg-green-dark">
                    <div
                      class="card-statistic-3 p-4 card-height-reports"
                      style={{ height: "60px" }}
                    >
                      <div class="card-icon card-icon-large">
                      </div>
                      <div class="row align-items-center mb-2 d-flex">
                        <div class="col-10 card-text-alignment ">
                          <h5 class="d-flex align-items-center mb-0">
                            <b
                              style={{
                                color: "white",
                                fontSize: "17px",
                                marginTop: "2px",
                              }}
                            >
                              Total Scanned :
                            </b>{" "}
                            <span
                              style={{ marginBottom: "-2px", fontSize: "22px",marginLeft:"8px" }}
                            >
                              {
                                GetEpbScanningRoReport?.payload
                                  ?.totalCount===null?0: GetEpbScanningRoReport?.payload
                                  ?.totalCount
                              }
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-md-3 box ml-4">
                  <label className="label_text">
                    <b style={{ color: "black" }}>
                      Total e-PB found duplicate :
                    </b>{" "}
                    {GetEpbScanningRoReport?.payload?.duplicateEpbScannigCount}
                  </label>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        <div className=" col-md-12">
          <Table
            placeholder="Search"
            globalsearch={true}
            selectall={true}
            columns={columns}
            emptyMessage="No Record Found"
            data={tabledata?.length === 0 ? [] : tabledata}
            size={5}
            tableClassNameCheck="contenttable-eroll"
            pagination
            records
            gotopage
            rows
            numberrows={totalNoOfRecords}
          />
        </div>
      </div>
    </LeftMenu>
  );
};

export default EpbScanningRoReport;
